import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { PolicyBtn } from '../PolicyBtn';

export const CookiesBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');

        if (!consent) {
            setVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setVisible(false);
    };

    if (!visible) return null;
    return (
        <div className={styles.cookieBanner}>
            <div className={styles.wrapper}>
                <p>
                    Продолжая использовать сайт, Вы даете согласие ООО «Кибер Форм
                    Системс» на обработку файлов cookies и пользовательских данных,
                    собираемых посредством агрегаторов статистики посетителей веб-сайтов,
                    в целях ведения статистики посещений сайта. Если Вы не хотите, чтобы
                    Ваши вышеперечисленные данные обрабатывались, просим отключить
                    обработку файлов cookies и сбор пользовательских данных в настройках
                    Вашего браузера или покинуть сайт.
                </p>
                <div className={styles.policy}>
                    <PolicyBtn />
                </div>

                <button type="button" onClick={acceptCookies}>
                    Принять и закрыть
                </button>
            </div>
        </div>
    );
};
